import { Skeleton } from "antd";

export const SlideSkeleton = ({
  width,
  height,
}: {
  width: number;
  height: number;
}) => <Skeleton.Node active style={{ width, height }} />;
